import { render, staticRenderFns } from "./main.vue?vue&type=template&id=3da99404&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"
import style0 from "./style.css?vue&type=style&index=0&id=3da99404&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da99404",
  null
  
)

export default component.exports